import uploadWhyHostData from '../../../actions/siteadmin/uploadWhyHostData'
import { demoRestriction } from '../../../helpers/DemoRestriction/demoRestriction';

async function submit(values, dispatch) {

	const isRestrict = await dispatch(demoRestriction({}));
	if (isRestrict) return;

	let dataError = false, dataList;
	values.dataList && values.dataList.map((item) => {
		item.fileName ? dataError = false : dataError = true
	});

	dataList = values.dataList && values.dataList.length > 0 ? JSON.stringify(values.dataList) : JSON.stringify([]);
	await dispatch(uploadWhyHostData(dataList))
}

export default submit;